module.exports = __webpack_public_path__ + "img/122.352b7da.png";